import {createAction} from '@reduxjs/toolkit'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {isMobile} from '../../../../commons/selectors/environment'
import {isCalendar, isMobileDailyListLayout} from '../selectors/list-settings'
import {getComponentConfig, getValue} from '../selectors/settings'
import {createAsyncAction} from '../services/redux-toolkit'
import {State} from '../types/state'
import {closeMonthlyCalendarPopup, openAnyEventDetails} from './calendar-layout'
import {reloadEvents} from './events'

interface StyleParams {
  numbers: Record<string, number>
  booleans: Record<string, boolean>
}

export const updateStyleParams = createAction<Record<string, number | boolean>>('UPDATE_STYLE_PARAMS')

export const updateStyles = createAsyncAction<void, StyleParams>(
  'UPDATE_STYLES',
  async (params, {dispatch, getState, extra: {flowAPI}}) => {
    const calendarRevampEnabled = flowAPI.experiments.enabled(ExperimentNames.CalendarRevamp)
    const layoutChanging = isLayoutChanging(getState(), params, calendarRevampEnabled)

    await dispatch(
      updateStyleParams({
        ...params.numbers,
        ...params.booleans,
      }),
    )

    if (layoutChanging) {
      await dispatch(reloadEvents())

      if (calendarRevampEnabled) {
        const state = getState()
        const mobile = isMobile(state)

        if (isCalendar(state)) {
          mobile ? dispatch(closeMonthlyCalendarPopup()) : dispatch(openAnyEventDetails())
        } else if (mobile && isMobileDailyListLayout(getComponentConfig(state))) {
          dispatch(openAnyEventDetails())
        }
      }
    }
  },
)

const isLayoutChanging = (state: State, params: StyleParams, calendarRevampEnabled: boolean) => {
  const {settings} = getComponentConfig(state)
  const updatedSettings = {...settings, ...params.numbers}
  const {listLayout, widgetLayout, recurringFilter} = settings
  const {
    listLayout: updatedListLayout,
    widgetLayout: updatedWidgetLayout,
    recurringFilter: updatedRecurringFilter,
  } = updatedSettings

  const mobileWidgetLayoutNew = getValue(settings, true, 'mobileWidgetLayoutNew')
  const updatedMobileWidgetLayoutNew = getValue(updatedSettings, true, 'mobileWidgetLayoutNew')
  const mobileWidgetListLayoutType = getValue(settings, true, 'mobileWidgetListLayoutType')
  const updatedMobileWidgetListLayoutType = getValue(updatedSettings, true, 'mobileWidgetListLayoutType')

  const isParamChanging = (newValue, oldValue) => newValue !== undefined && oldValue !== newValue

  return (
    isParamChanging(updatedListLayout, listLayout) ||
    isParamChanging(updatedWidgetLayout, widgetLayout) ||
    isParamChanging(updatedRecurringFilter, recurringFilter) ||
    (calendarRevampEnabled &&
      (isParamChanging(updatedMobileWidgetLayoutNew, mobileWidgetLayoutNew) ||
        isParamChanging(updatedMobileWidgetListLayoutType, mobileWidgetListLayoutType)))
  )
}
